import { Geometry, Vector3 } from 'three';
import * as v3 from './vector3';

/** rotate geometry around direction **IN PLACE**
 *
 * returns the modified geometry
 */
export function rotate_ip(direction: Vector3, geometry: Geometry) {
    const phi = v3.cc_angle(
        v3.normalise(new Vector3(direction.x, direction.y, 0)),
        v3.Axes.X,
        v3.Axes.Z
    );

    const theta = v3.cc_angle(
        v3.copy(direction).applyAxisAngle(v3.Axes.Z, phi),
        v3.Axes.X,
        v3.Axes.Y
    );

    return geometry
        .rotateZ(-Math.PI / 2)
        .rotateY(2 * Math.PI - theta)
        .rotateZ(2 * Math.PI - phi);
}
